module.exports = __webpack_public_path__ + "img/wei.0dc2ad3e.png";